export let jokes =
    [
        "Welcher Wein gedeigt am Fuß eines Vulkans? Glühwein.",
        "Wie nennt man einen kleinen Matrosen, der sich nicht wäscht? Ein Meerschweinchen!",
        "Aus welchem Land kommen Schornsteinfeger? Aus Rußland!",
        "In welchem Land ist man so langsam wie eine Schnecke? In Kriechenland.",
        "Warum haben sie in Ägypten nächste Woche keine Schule?! Sphinxferien!",
        "Wann gehen U-Boote unter? Am Tag der offenen Tür.",
        "Warum darf das Neutron nicht in die Disco? Heute nur geladene Gäste!",
        "Warum findet ein Henker nie den Rückweg? Weil der nur die Hinrichtung kennt.",
        "Warum fliegen Störche im Winter in den Süden? Weil Laufen zu lange dauern würde.",
        "Warum gibt es in Booten keinen Honig? Weil es auf Schiffen ka-bienen gibt.",
        "Warum haben Fische Schuppen? Damit sie ihre Fahrräder unterstellen können.",
        "Warum ist der Florist über seine Lieferung traurig? Sie ist eingegangen.",
        "Warum können Seeräuber schlecht mit Kreisen Rechnen? Weil sie Pi-Raten!",
        "Warum können Skelette so schlecht lügen? Die sind so einfach zu durchschauen.",
        "Warum leben Haie im Salzwasser? Weil sie von Pfefferwasser niesen müssen.",
        "Warum sind bei IKEA Pfeile am Boden? Weil es ein Einrichtungshaus ist.",
        "Warum sind Fußballer eine Gefahr im Straßenverkehr? Weil sie bei rot gehen müssen.",
        "Warum steht die Freiheitsstatue in New York? Weil sie sich nicht setzen kann.",
        "Warum summen Bienen? Weil sie den Text nicht kennen.",
        "Warum wachsen auf dem Mond keine Blumen? Zu wenig Erde.",
        "Was benutzt ein Bär als Eingabegerät? Eine Tatzatur.",
        "Was bestellt ein Maulwurf im Restaurant? Ein Drei-Gänge-Menü.",
        "Was denken sich die Gletscher zum Klimawandel? Wir werden Seen.",
        "Was erzählen sich holländische Süßspeisen am liebsten? Vla-chwitze.",
        "Was erzählt Weizen sich gegenseitig beim Campen? Grieselgeschichten.",
        "Was essen Autos am liebsten? Parkplätzchen.",
        "Was essen Piraten am liebsten? Kapern.",
        "Was findet man beim Kannibalen in der Dusche? Head and Shoulders.",
        "Was für ein Gefühl hatte Mozart beim Komponieren? Einen Haydn-Spaß.",
        "Was gibt es bei Olympia-Teilnehmern zum Nachtisch? Fackelpudding!",
        "Was hat acht Arme und fliegt durchs Weltall? Eine Krakete.",
        "Was hat acht Beine und schummelt? Eine Mogelspinne.",
        "Was hat ein Mann, der im Dreieck läuft? Kreislaufprobleme.",
        "Was hat einen Beutel und schießt? Ein Penguruh.",
        "Was hat Haare und wird gebraten? Bartkartoffeln.",
        "Was hoppelt über die Wiese und raucht aus den Ohren? Ein Kaminchen.",
        "Was isst eine Sadomaso Frau vor Weihnachten? Domina-Steine.",
        "Was isst Familie Biber zu abend? Tischstäbchen.",
        "Was ist braun und hilft dir, wenn du traurig bist? Ein Trost-brot.",
        "Was ist braun und hängt mit nem Warndreieck im Baum? Ein Pannenzapfen.",
        "Was ist braun und schwimmt unter Wasser? Ein U-Brot.",
        "Was ist braun, kann fliegen und macht Kindern die Zähne kaputt? Die Toffi-Fee!",
        "Was ist braun, lebt im Nil und schmeckt lecker? Ein Schokodil.",
        "Was ist braun, lecker und gesund? Schogolade.",
        "Was ist bunt und will dringend aus dem Zimmer raus? Ein Fluchtsalat.",
        "Was ist bunt, leuchtet und kann nicht schwimmen? ein Bagger mit Lichterkette.",
        "Was ist bunt, süß und ein bisschen einfach gestrickt? Ein Dummibärchen.",
        "Was ist das Gegenteil von Japan? Neinpan.",
        "Was ist der unförmigste Seevogel von Nordfriesland? Die Amöve.",
        "Was ist die größte Anerkennung unter Aquarellisten? Verläuft bei Dir!",
        "Was ist durchsichtig, stinkt und ignorant? Ein Schnurz.",
        "Was ist ein Cowboy ohne Pferd? Ein Sattelschlepper.",
        "Was ist ein Keks unter einem Baum? Ein schattiges Plätzchen.",
        "Was ist ein nackter Ritter? Ent-rüstet!",
        "Was ist eine Glühbirne, die schockiert zu Boden fällt? Fassungslos!",
        "Was ist eine Kastanie hinter Gittern? Eine Knastanie.",
        "Was ist gelb und flattert im Wind? Eine Fahnane.",
        "Was ist gelb und hüpft durch den Wald? Ein Postfrosch.",
        "Was ist gelb und kann nicht schwimmen? Ein Bagger. Und warum? Weil er nur einen Arm hat.",
        "Was ist gelb und läuft den Baum hoch? Ein Posthörnchen.",
        "Was ist gelb und schießt? Eine Banone.",
        "Was ist gelb und schwimmt über'n See? Eine Schwanane.",
        "Was ist gelb und steht am Fenster? Eine Spannanas.",
        "Was ist gesund, kräftig und spielt den beleidigten? Das andere Schmollkornbrot.",
        "Was ist groß, braun und schreibt undeutlich? Ein Kritz-li-bär.",
        "Was ist groß, grau und interessiert niemanden? Ein Irrelephant.",
        "Was ist groß, grau und ruft gleich an? Ein Telefant.",
        "Was ist grün und fliegt durchs Weltall? Ein Salatelit.",
        "Was ist grün und fährt Pandabären zur Arbeit? Ein Bam-bus.",
        "Was ist grün und gewinnt jedes Rennen? Ein Schnellerie.",
        "Was ist grün und hüpft durch den Wald? Ein Rudel Gurken.",
        "Was ist grün und liegt im Sarg? Eine Sterbse.",
        "Was ist grün und macht die Toilette sauber? Ein Klokodil.",
        "Was ist grün und schnarcht am Wegesrand? Eine Pennnessel.",
        "Was ist grün und sitzt auf dem Klo? Der Kacktus.",
        "Was ist grün und tut weh, wenn man es ins Auge kriegt? Ein Billardtisch.",
        "Was ist grün und will dringend ins Zimmer? Ein Klopfsalat.",
        "Was ist grün, blind und spielt hervorragend Klavier? Kiwi Wonder.",
        "Was ist grün, hängt an der Türklinke und guckt durchs Schlüsselloch? Ein Spionat.",
        "Was ist grün, sauer und versteckt sich vor der Polizei? Ein Essig-Schurke.",
        "Was ist grün, schlau und stellt viele Fragen? Günther Lauch.",
        "Was ist grün, sitzt auf einem Baum und wenn es runterfällt bist Du verletzt? Ein Billiardtisch.",
        "Was ist grün, springt durchs Gras und ist super happy? Eine Freuschrecke.",
        "Was ist heiß und flauschig? Eine Fellkartoffel.",
        "Was ist klein und schwarz und dreht sich auf der Wiese? Ein Maulwurf beim Hammerwerfen.",
        "Was ist klein, glitschig und immer schlecht gelaunt? Eine Maulquappe.",
        "Was ist langsam, wird steinalt und macht einen Riesenlärm? Eine Schildtröte.",
        "Was ist lila und bedient im Restaurant? Eine Obergine.",
        "Was ist lässig und hat einen Euter? Eine Kuhl.",
        "Was ist orange und kann nicht still sitzen? Eine Zappelsine.",
        "Was ist orange und läuft durch die Berge? Eine Wandarine.",
        "Was ist rot und schlecht für die Zähne? Ein Ziegelstein.",
        "Was ist rot und steht im Wald? Ein Kirsch.",
        "Was ist rot und wiehert? Eine Pferdbeere.",
        "Was ist rot, rund und sitzt auf dem Klo? Eine Klomate.",
        "Was ist schwarz, rot und lebt in der Arktis? Ein Pinguin mit Sonnenbrand.",
        "Was ist schwarz-weiß und explodiert? Ein Sprenguin.",
        "Was ist schwarz-weiß und hüpft auf und ab? Ein Springuin.",
        "Was ist schwarz-weiß und sitzt auf der Schaukel? Ein Schwinguin.",
        "Was ist süß und schwingt sich von Torte zu Torte? Tarzipan.",
        "Was ist süß, klebrig und geht durch die Wüste? Ein Karamel.",
        "Was ist unter der Erde und stinkt? Eine Furzel.",
        "Was ist weiß, ungesund und fliegt über die Wiese? Biene Mayo.",
        "Was ist weiß und guckt durchs Schlüsselloch? Ein Spannbettlaken.",
        "Was ist weiß und schnarcht auf der Wiese? Ein Schlaf.",
        "Was ist weiß und springt von Baum zu Baum? Ein Tierarzt bei der Zeckenimpfung.",
        "Was ist weiß und tanz im Wald ums Feuer? Rumpelpilzchen.",
        "Was ist wohlhabend und springt von Ast zu Ast? Ein Scheichhörnchen.",
        "Was kauft ein Mann mit zwei linken Füßen im Schuhgeschäft? Flip Flips.",
        "Was kommt aufs Brot und schmeckt nach Kleister? Kleberwurst.",
        "Was lebt in der Savanne und ist immer sauber? Eine Hygiäne.",
        "Was liegt am Strand und kann man nicht gut verstehen und ist auch noch erkältet? Eine Niesnuschel.",
        "Was liegt am Strand und kann man nicht gut verstehen? Eine Nuschel.",
        "Was machen PiratInnen, wenn Sie nicht mehr weiterwissen? Einen Arrrrrrrbeitskreis.",
        "Was machen Tiere in der Disko? Sie diskotieren.",
        "Was machen zwei Bäume, wenn sie einen trinken wollen? Sie gehen in ihre Stammkneipe.",
        "Was machen zwei wütende Schafe? Sie kriegen sich in die Wolle.",
        "Was macht der Mathematiker beim Skifahren? Er rechnet mit Brüchen.",
        "Was macht ein arbeitsloser Schauspieler? Spielt keine Rolle.",
        "Was macht ein Clown im Büro? Faxen.",
        "Was macht ein schwuler Wurm im Salat? Er schmeißt die Schnecken raus.",
        "Was macht eine Bombe im Bordell? Puff.",
        "Was macht eine Bombe im Treppenhaus? Hochgehen.",
        "Was macht eine Ente auf dem Router? Nat.",
        "Was macht man mit einem Hund ohne Beine? Um die Häuser ziehen.",
        "Was passiert wenn man Cola und Bier gleichzeitig trinkt? Man colabiert.",
        "Was piekst und fliest das Bad? Ein Kachelschwein.",
        "Was sagt der frustrierte Origami-Lehrer zu seinem Schüler? Kannste knicken!",
        "Was sagt der Fuchs im Hühnerstall? Raus aus den Federn!",
        "Was sagt der große Stift zum kleinen Stift? Wachs-mal-Stift.",
        "Was sagt der Holzwurmpapa abends zu seinen Kindern? Husch, husch ab ins Brettchen.",
        "Was sagt der Teig bei der Hochzeit? Ich bin ganz gerührt!",
        "Was sagt ein Ackerbesteller bei gutem Wetter? Das Land-wird.",
        "Was sagt ein Gen, wenn es ein anderes trifft? Halogen.",
        "Was sagt ein Pirat im Pferdestall? A, Heu.",
        "Was schwimmt auf dem Teich und fängt mit Z an? Zwei Enten.",
        "Was schwimmt im Meer und kann addieren? Ein Oktoplus.",
        "Was sind die teuersten Tomaten? Die Geldautomaten.",
        "Was sitzt am Frühstückstisch und winkt? Ein Grüsli.",
        "Was sitzt auf dem Baum und schreit \"Aha!\"? Ein Uhu mit Sprachfehler.",
        "Was sitzt auf dem Turm und macht alle 15 Minuten Schuhu? Der Turmuhur.",
        "Was sitzt auf einem Baum und winkt? Ein Huhu!",
        "Was sitzt ganz hinten im Brotkasten und ist beleidigt? Ein Schmollkornbrot.",
        "Was sitzt im Baum und weint? Eine Heule!",
        "Was steht auf dem Herd und ist total geheim? Ein Topf Secret!",
        "Was steht Weihnachten im Wohnzimmer und ist kaputt? Ein Pannenbaum.",
        "Was studiert man für einen Führerschein? Fahr-ma-kologie.",
        "Was wird oft übersehen? Ein Gartenzaun.",
        "Welche Fische haben die beste Mundhygiene? Die Zahnprophylachse.",
        "Welche Handwerker essen am meisten? Maurer, die verputzen ganze Häuser.",
        "Welche Schuhe tragen Raubfische sehr gern? Hai-Heels.",
        "Welche Weinsorte wächst am Fuße des Vesuvs? Glühwein.",
        "Welcher Fisch nervt im Unterricht? Na der Stör!",
        "Welches Getränk trinken Firmenchefs? Leitungswasser.",
        "Welches ist die lustigste Automarke? Scherzedes.",
        "Welches Maultier sitzt in der Bar und trink Cappuccino? Das Cafémel.",
        "Welches Obst geht immer in die Kirche? Die Frommbeere.",
        "Welches Tier kümmert sich um Meeresbewohner, denen es nicht gut geht? Die Krakenschwester.",
        "Wie nennt man ein südamerikanisches Kameltier, wenn es betrunken ist? Alkpaka.",
        "Wer ist bunt, flattert durch die Luft und hilft wo er nur kann? Ein Retterling.",
        "Wer ist grün, kann zaubern und riecht streng? Stinkerbell.",
        "Wer kümmert sich um die Gräten der Meeresbewohner? Der Oktopäde.",
        "Wer mit Nüssen zahlt, darf sich nicht wundern, wenn Affen für ihn arbeiten.",
        "Wer wohnt im Dschungel und schummelt? Mogli.",
        "Wie begrüßen sich Schönheitschirurgen? Na was machst Du denn für ein Gesicht?",
        "Wie berechnet eine Kuh die Fläche ihrer Weide? Mit der Muhtiplikation.",
        "Wie heißt das intelligenteste Gemüse? Schlaubergine.",
        "Wie heißt ein Spanier ohne Auto? Carlos.",
        "Wie kastriert man einen Kühlschrank? Tür auf, Eier raus, Tür zu.",
        "Wie nennt man das Küchengerät dass dir heimlich die Süßigkeiten wegisst? Die Spülnaschine.",
        "Wie nennt man das Oberteil von Meerjungfrauen? Algebra.",
        "Wie nennt man den Flur eines Iglus? Eisdiele!",
        "Wie nennt man die Steigerung von Buchstabensuppe? Wörtersee.",
        "Wie nennt man ein kleines schwäbisches Schwein, das um Hilfe ruft? Ein Notrufsäule.",
        "Wie nennt man ein Monster mit Schnupfen? Rotzilla.",
        "Wie nennt man ein Rudel aggressiver Wölfe? Wolfgang.",
        "Wie nennt man ein verschwundenes Rindvieh? Oxford.",
        "Wie nennt man ein weißes Mammut? Hell-mut!",
        "Wie nennt man eine Biene, die diagonal fliegt? Eine Quersumme.",
        "Wie nennt man eine Frucht, die ein großes Anwesen hat? -- Eine Hektarine.",
        "Wie nennt man einen ausgehungerten Frosch? Magerquark.",
        "Wie nennt man einen Bären der \"Granufink\" braucht? Ein Pullerbär.",
        "Wie nennt man einen Delfin mit einer Unterhose auf dem Kopf? Slipper.",
        "Wie nennt man einen dicken Schriftsteller? Kugelschreiber!",
        "Wie nennt man einen dünnen Weihnachtsmann? Nikolauch.",
        "Wie nennt man einen extrem dünnen Frosch? Magerquak.",
        "Wie nennt man einen Gerd, der den Rasen mäht? Gerd-ner.",
        "Wie nennt man einen Hering, der am Flughafen arbeitet? Einen Zollmops.",
        "Wie nennt man einen Hering, der beleidigt ist? Einen Schmollmops.",
        "Wie nennt man einen Hering, der die besten Memes postet? Einen Lolmops.",
        "Wie nennt man einen Hering, der doofe Kommentare schreibt? Einen Trollmops.",
        "Wie nennt man einen Hering, der gerne Atombombentests macht? Einen Atollmops.",
        "Wie nennt man einen Hering, der gerne Befehle befolgt? Einen Jawollmops.",
        "Wie nennt man einen Hering, der gerne Fußball mag? Einen (Mehmet) Schollmops.",
        "Wie nennt man einen Hering, der gerne strickt? Einen Wollmops.",
        "Wie nennt man einen Hering, der immer alles aufschreibt? Einen Protokollmops.",
        "Wie nennt man einen Hering, der immer alles machen muss? Einen Sollmops.",
        "Wie nennt man einen Hering, der immer nur traurige Musik spielt? Einen Mollmops.",
        "Wie nennt man einen Hering, der immer sauer ist? Einen Grollmops.",
        "Wie nennt man einen Hering, der immer total begeistert ist? Einen Tollmops.",
        "Wie nennt man einen Hering, der Regie führt? Einen (Uwe) Bollmops.",
        "Wie nennt man einen Hering, der sehr unkultiviert ist? Einen Prollmops.",
        "Wie nennt man einen Hering, der sich für Umfragen interessiert? Einen Pollmops.",
        "Wie nennt man einen Hering, der total besoffen ist? Einen Vollmops.",
        "Wie nennt man einen Hering, der total gerne Puppen mag? Einen Dollmops.",
        "Wie nennt man einen Hund der gerne Äpfel isst? Apfelpudel.",
        "Wie nennt man einen kleinen Matrosen, der sich nicht wäscht? Na: Ein Meerschweinchen!",
        "Wie nennt man einen kleinen Türsteher? Sicherheitshalber.",
        "Wie nennt man einen Landwirt mit Studium? Einen Ackerdemiker.",
        "Wie nennt man einen überfahrenen Vogel? Piepmatsch!",
        "Wie nennt man Fernsehverbot auf Russisch? Njetflix.",
        "Wie nennt man Han Solo, wenn er in der Disko rumtanzt? Han Twerker.",
        "Wie nennt man jemand der nur so tut als würde er etwas werfen? Einen Scheinwerfer.",
        "Wie nennt man jemanden der DIN A4 Blätter scannt? Skan-din-a-vier.",
        "Wie nennt man Kaninchen im Fitnessstudio? Pumpernickel.",
        "Wie viel wiegen ein Pferd und ein Hund zusammen? Ein PfHund!",
        "Wie viele Psychotherapeuten braucht man um eine Glühbirne zu wechseln? Einen, aber die Birne muss auch wollen.",
        "Wie viele Softwareentwickler braucht man um eine Glühbirne zu wechseln? Keinen, das ist eindeutig ein Hardwareproblem.",
        "Wie war die Stimmung in der DDR? Sie hielt sich in Grenzen.",
        "Wieso können Seeräuber keinen Kreis fahren? Weil sie Pi raten.",
        "Wo geht Darth Vader shoppen? In der Darth Mall!",
        "Wo gibt es die meisten Gespenster in Europa? In Buuuuuuuuhdapest!",
        "Wo machen Kühe Urlaub? Auf Kuuuhba!",
        "Wo wohnen Katzen? Im Mietz-Haus!",
        "Wohin geht ein Baum, wenn er Rückenschmerzen hat? Zum Kiefer-Orthopäden.",
        "Wohin geht ein Zyklop, wenn er nicht gut sieht? Zum Augearzt.",
        "Womit backen Schlümpfe? Mit Garga-Mehl.",
        "Womit ist der Boden eines Iglus ausgelegt? Mit Eisdielen.",
        "Womit kann man eine Webseite hosten, aber nur wenn Vollmond ist? Mit einem Werserver.",
        "Womit verprügeln sich Schafe? Mit dem Mäh-Drescher.",
        "Wovon träumt eine Katze nachts? Von einem Muskelkater.",
        "Wussten Sie, dass Esoteriker häufig zur Arbeit pendeln...?",
        "Zu welchem Arzt geht Pinocchio? Zum Holz-Nasen-Ohren-Arzt.",
        "\"Hallo, einen Martini bitte.\" \"Dry?\" \"Nee, einer reicht!\"",
        "Treffen sich zwei Bäume. Sagt der eine \"Servus, wie gehts'?\" Sagt der andere \"Halt's Maul, Bäume können nicht reden!\"",
        "Treffen sich ein Blinder und ein Einbeiniger. Sagt der Einbeinige \"Ich tret dir gleich in den Arsch!\". Sagt der Blinde \"Des will ich sehn!\"",
        "Busfahrer: Möchten Sie sich nicht setzen? Mann: Nein, ich habe es eilig.",
        "Beim Zahnarzt: \"Das kann jetzt ein bisschen weh tun.\" \"Kein Problem.\" \"Ich hab seit 3 Jahren ein Verhältnis mit Ihrer Frau.\"",
        "Fragt der Polizist: Haben sie Restalkohol? Nee, alles ausgetrunken.",
        "Fliegt ein Kuckuck übers Meer. Grüßt ihn ein Hai: \"Hi!\" \"Kuckuck!\"",
        "Gehen zwei Zahnstocher durch den Wald. Kommt ein Igel vorbei. Sagt der eine Zahnstocher: \"Ich wusste gar nicht, dass hier ein Bus fährt.\"",
        "Ich brauche eine Krankschreibung? Was fehlt ihnen denn? Eine Krankschreibung.",
        "Im Restaurant: Isst Du gerne wild? Nein, ganz normal und langsam.",
        "Kommt ein Frosch in den Milchladen. Fragt die Verkäuferin: \"Was willst du denn?\" Sagt der Frosch: \"Quak.\"",
        "Kommt ein Igel in die Konditorei: \"Einmal Rumkugeln bitte\" -  Wenn sie wollen, wir haben gerade frisch gewischt.",
        "Sagt der Pessimist: \"Schlimmer geht nicht!\" Sagt der Optimist: \"Doch!\"",
        "Sagt der Walfisch zum Tuhnfisch: \"Was wollen wir tun, Fisch?\" Sagt der Thunfisch: \"Du hast die Wahl, Fisch!\"",
        "Sagt die eine Kerze zur anderen: Du, ist Wasser eigentlich gefährlich? Sagt die andere: Davon kannst Du ausgehen.",
        "Treffen sich zwei Magneten: \"Was zieh ich heute bloß an?\"",
        "Unterhalten sich zwei Fliesenleger: \"Wo sind denn die ganzen Fliesen hin?\" \"Oh, die muss ich wohl verlegt haben.\"",
        "Dennis: \"Was magst du?\" Mandy aus Dresden: \"Ich mag Dischdennis\"",
        "Was ist viereckig, hat Noppen und einen Sprachfehler? Ein Legosteniker.",
        "Was essen Supermodels, wenn’s mal schnell gehen muss? Ein Laufsteak.",
        "Warum können Bienen so gut rechnen? Weil sie sich den ganzen Tag mit Summen beschäftigen.",
        "Was ist rot und schlecht für die Zähne? Ein Backstein.",
        "Wie nennt man einen Boomerang, der nicht zurückkommt? Stock.",
        "Wie heißt eine Oma beim Geheimdienst? Top Sigrid!",
        "Was sucht ein einarmiger in der Stadt? Den Second-Hand-Shop!",
        "Wie heißt ein schwedischer Türsteher? Lasse Reinströmen!",
        "Was machen Pilze auf einer Pizza? Als Belag funghieren!",
        "Wie nennt man ein Dieb in der U-Bahn? Metropole.",
        "Was wühlt sich durch den Himmel? Ein Pflugzeug!",
        "Was sagt der große Stift zum kleinen Stift? Wachsmalstift!",
        "Welches Gas lässt Autos verschwinden? Polenstoffdioxid.",
        "Was ist gelb und filmt von oben? Die Zidrohne!",
        "Was ist ein Pferd auf Schienen? Selbstmordgepferdet!",
        "Wie nennt man einen russischen Baum? Dimitree!",
        "Wie nennt man einen türkischen Baum? Aische!",
        "Was ist gelb-schwarz und fliegt durch die Luft? Ein Rudel Senfkörner in Lederjacken!",
        "Was ist rot und kämpft sich durch den Salat? Ein Rambodieschen!",
        "Was ist braun und hängt an der Wand? Ein Plakot.",
        "Was ist klein, gelb und guckt Richtung Osten? Eine Mekkaroni!",
        "Was sagt ein katholischer Priester, wenn er eine leere Kapelle in Afrika sieht? Heidenai!",
        "Wie unterbricht man eine Schlägerei zwischen zwei Blinden? Man schreit \"Ich wette auf den mit dem Messer!\"",
        "Was ist gelb und schaut durchs Schlüsselloch? Eine Spannane.",
        "Warum kann man ein Wurstbrot nicht anrufen? Weil's belegt ist!",
        "Wohin fliegt ein schwuler Adler? Zu seinem Horst.",
        "Wie erkennt man eine männliche Schokolade? An den Nüssen!",
        "Wo geht Darth Vader shoppen? In der Darth Mall!",
        "Warum legen Hühner Eier? Wenn sie sie schmeißen, gehen sie doch kaputt!",
        "Was haben Elektriker in der Hose? Einen Kurzen.",
        "Was ist das Gegenteil von Katalog? Kata-sagte-die-Wahrheit.",
        "Welches Werkzeug hat immer gute Ideen? Der Vorschlaghammer!",
        "Wie bestellt ein Ossi einen Weihnachtsbaum auf Englisch? A tännschen please!",
        "Warum han die Araber ka Brot? Weils ka-Mehl ham!",
        "Welche Vögel können nicht hören? Die Tauben!",
        "Was ist ein Lüneburger, der aus der Kirche ausgetreten ist? Ein Lüneburger Heide!",
        "Warum fliegen Storche im Winter in den Süden? Weil Laufen zu lange dauern würde.",
        "Was ist braun, piept und fliegt durch die Luft? Ein Kotkelchen.",
        "Was passiert, wenn man bei Ikea klaut? Man wird vermöbelt.",
        "Was ist das Gegenteil von Reformhaus? Reh hinterm Haus.",
        "Wie nennt man eine iPhone-Hülle noch? Apfeltasche.",
        "Was hat ein Mann ohne Beine? Erdnüsse.",
        "Welche Sprache wird in der Sauna gesprochen? Schwitzerdeutsch.",
        "Was ist paniert und raubt Leute aus? Ein Zigauner-Schnitzel.",
        "Was entsteht, wenn sich ein Igel und ein Regenwurm paaren? Eine Rolle Stacheldraht.",
        "Warum trinken Mäuse keinen Alkohol? Weil sie Angst vorm Kater haben.",
        "Woraus wurde das Haus von Jesus gebaut? Aus Jerusa-Lehm.",
        "Was kriegt ein Kannibale der zu spät zum Essen kommt? Die kalte Schulter.",
        "Wie verbrennt man ganz schnell 900 Kalorien? Indem man die Pizza im Ofen vergisst.",
        "Wie nennt man springende Pilze? Jumpingnons.",
        "Was ist kalt, blau und steht am Straßenrand? Eine Frostituierte.",
        "Was hängt im Urwald an den Bäumen? Urlaub.",
        "Was war Hitlers Lieblings-Süssigkeit? Nazipan.",
        "Wieviel wiegen ein Pferd und ein Hund zusammen? Ein Pfund.",
        "Welchen Preis gewinnen besonders ruhige und brave Hunde? Den No-Bell-Preis.",
        "Was sagt man zu einem Inder, der stolpert? Fall nicht Hindu.",
        "Was steht auf dem Grabstein eines Mathematikers? \"Damit hat er nicht gerechnet.\"",
        "Was heisst Wasser auf Russisch? Wodka Zero.",
        "Warum stehen Frauen immer in der Küche? Wegen der Herdanziehungskraft.",
        "Wie nennt man einen Ritter ohne Helm? Willhelm.",
        "Was ist gesund und schwimmt auf dem Wasser? Ein Vollkornboot.",
        "Was ist ein Einarmiger mit einem Kartenspiel? Mischen Impossible.",
        "Wie nennt man einen Liliputaner, der 20 Kinder hat? Fruchtzwerg.",
        "Was sitzt im Baum und trägt einen Turban? Ein Scheichhörnchen.",
        "Wie heißt die Frau von Herkules? Fraukules.",
        "Was ist braun, süß und rennt durch den Wald? Eine Joggolade.",
        "Was war der Name des ersten Taxifahrers? Schlimmes. Denn schon in der Bibel stand: \"Schlimmes wird euch wieder fahren.\"",
        "Womit kann man Berge glätten? Mit dem Hügeleisen.",
        "Wie nennt man eine weibliche Pute? Putin.",
        "Was macht eine Eskimofrau auf der Eisscholle? Abtreiben.",
        "Was sind vier Nazis in der Ecke? Ein rechter Winkel.",
        "Was läuft durch den Wald und schiesst mit dem Gewehr? Schrotkäppchen.",
        "Was ist eine Glühbirne, wenn sie zu Boden fällt? Fassungslos.",
        "Was macht ein Mathematiker in seinem Garten? Wurzeln ziehen.",
        "Wie nennt man ein hartgefrorenes Mammut? Hartmut.",
        "Was macht man, wenn man eine Schlange in der Wüste sieht? Sich hinten anstellen.",
        "Was heisst Sonnenuntergang auf finnisch? Helsinki.",
        "Was sitzt im Baum, hat Kopfschmerzen und kann nachts gut sehen? Eine Beule.",
        "Was sagt ein irakischer Bäcker zu seinem Lehrling? Bagdad.",
        "Was passiert, wenn man sich an Pfannkuchen überfrisst? Man crêpiert.",
        "Was lebt in der Savanne und ist immer sauber? Eine Hygiäne.",
        "Was gräbt und ist aus der Puste? Eine Schnaufel.",
        "Welches Gemüse essen Sanitäter am liebsten? Rettich.",
        "In welcher Maßeinheit messen Hunde ihre Temperatur? In Belgrad.",
        "Was macht ein Reh bei Haarausfall? Es geht in die Rehhaarklinik.",
        "Was benutzt ein Geizhals zum frisieren? Spar-gel.",
        "Was ist schwarz-weiss gestreift und berührt nicht den Boden? Ein Schwebra.",
        "Was unterscheidet Bill Gates von Batman? Batman hat den Kampf gegen den Pinguin gewonnen.",
        "Wie viele Leute braucht man, um einen Hubschrauber zu fliegen? Zwei - Einer hupt, der andere schraubt.",
        "Kann man mit einem Tampon schreiben? In der Regel schon.",
        "Wie klingelt ein Gorilla an der Tür? King-Kong, King-Kong!",
        "Was macht ein Junkie unter der Dusche? Clean werden.",
        "Was hat ein Engel, wenn er in einen Misthaufen fällt? Kotflügel.",
        "Warum müssen Briefträger so oft zum Drogentest? Weil sie ständig was einwerfen.",
        "Was ist knusprig, braun und läuft mit einem Korb durch den Wald? Brotkäppchen.",
        "Was gibt es beim Imker zum Dessert? Bienenstich.",
        "Was macht ein Steak hinter dem Sofa? Es versteakt sich.",
        "Was macht ein Pirat am Computer? Er drückt die Enter-Taste.",
        "Welches Nagetier hat einen Sprachfehler? Der St-otter.",
        "Was hört man, wenn man sich einen Döner ans Ohr hält? Das Schweigen der Lämmer.",
        "Was ist rot, fruchtig und sehr kostbar? Eine Wertbeere.",
        "Was ist rund, braun und riecht unangenehm? Ein Stuhlkreis.",
        "Wo haben Jungs und Mädels heutzutage ihr erstes Date? Im Tindergarten.",
        "Was ist rot, gesund und gut gegen Eisenmangel? Schraubensaft.",
        "Wie nennt man behaarte Jugendliche? Fellteens.",
        "Was ist ein nackter Ritter? Margarita.",
        "Was macht ein Bäcker ohne Arme und Beine? Rumkugeln.",
        "Was ist ein Cowboy ohne Pferd? Ein Sattelschlepper.",
        "Wie nennt man einen Außerirdischen, der in der Informationstechnik arbeitet? ITalien.",
        "Wie nennt man einen Hund, der zaubern kann? Einen Labrakadabrador.",
        "Was fliegt über die Blumenweise und macht \"mus\", \"mus\"? Eine Biene im Rückwärtsgang.",
        "Was sagt der Gabelstaplerfahrer nach getaner Arbeit? Alles Paletti!",
        "Wie nennt man eine Straße, in der nur Männer stehen? Sackgasse.",
        "Was liegt auf dem Grund des Ozeans und zittert? Ein nervöses Wrack!",
        "Wie feiern Vegetarier? Sie lassen die Sau raus.",
        "Wie nennt man ein südamerikanisches Gewürzkraut? Brasilikum.",
        "Was ist eine verbreitete Krankheit bei Blechbläsern? Tubakulose.",
        "Wie nennt man einen Felsspalt, der jämmerliche Laute von sich gibt? Eine Schluchz.",
        "Was ist ein Deutscher im Weltraum? Ein All-Mann.",
        "Warum verirren sich Geimpfte seltener? Weil sie vor schweren Verläufen geschützt sind.",
        "Wie heißen die Einwohner Lettlands nach dem EU-Beitritt? Europaletten.",
        "Was sagt der Elefant zum nackten Mann? \"Wie kannst du nur durch das kleine Ding atmen?\"",
        "Wer macht beim Gemüsehändler die Öffentlichkeitsarbeit? Der Kressesprecher.",
        "Wie lautet die E-Mail-Adresse des Papstes? Urbi@Orbi.",
        "Was passiert, wenn eine Nähnadel ins Wasser fällt? Sie kriegt Wasser ins Öhr.",
        "Was ist das Lieblingstier eines Scrum Masters? Die Jira-fe.",
        "Was macht ein Wachmann in der Nudelfabrik? Er pasta auf!",
        "Wie nennt man ein Möbelstück, dass ein Mal bellt? Einwauschrank.",
        "Warum benutzt der Weihnachtsmann einen Schlitten? Weil sich alles andere nicht Rentier-t!",
        "Wo trinken Nilpferde ihren Tee? Am Hippo-Tee-Tisch.",
        "Wie nennt man einen Polizisten ohne Haare? Glatzcop!",
        "Welches Tier hat sein Arschloch auf dem Rücken? Das Polizeipferd.",
        "Was sagt man über einen Spanner, der gestorben ist? \"Er ist weg vom Fenster.\"",
        "Warum steht ein Pilz im Wald? Weil die Tannen zapfen.",
        "Warum sieht man Ameisen nie in Kirchen? Weil sie in Sekten sind.",
        "Wie nennt man einen Hund, der tief bellt? Einen Subwuffer.",
        "Wie nennt man Wale, die nicht ganz rund sind? O-Wale.",
        "Wie bezeichnet man einen indischen Straftäter? Als Delhiquenten!",
        "Was ist haarig, braun und fährt durch die Stadt? Der Kokosbus.",
        "Warum mag die AFD das Internet nicht? Das sind zu viele Links.",
        "Was hängt gebildet im Baum? Der Gymnasi-Ast.",
        "Was sagt der Buddhist beim Döner-Mann? Mach mich eins mit Allem!",
        "Wer macht den armen Fischen das Leben zur Hölle? Die Seemobben.",
        "Was macht die NSA an heißen Tagen so attraktiv? Die Beschattung.",
        "Wie viel wiegt 1 Hipster? 1 Insta-Gramm!",
        "Was lebt im Meer und steht auf Pop-Musik? Der Autotunefisch.",
        "Warum ist der Zirkusdirektor sauer auf seine Tochter? Weil er sie beim Clown erwischt hat.",
        "Wo wohnt die braune Kröte? Im dritten Teich!",
        "Wie nennt man Sex mit Gegenständen? Dingsbums.",
        "Wie bestellt man zwei Bier in einer englischen Kneipe? Tobias!",
        "Was ist weiß und fliegt über Griechenland? Feta Pan.",
        "Was ist an der Schweiz so toll? Keine Ahnung, aber die Flagge ist schon mal ein großes Plus...",
        "Welches Land ist 1,20 m lang und 80 cm breit? Palettland.",
        "Haben Menschen im Land der aufgehenden Sonne Angst vor schlechten Wortspielen? Ja, panische.",
        "Was bekommt man von verdorbenem Fisch? Dorschfall.",
        "Warum wurde der Töpfer entlassen? Er hatte sich im Ton vergriffen.",
        "Womit tauschen Haie heiße Küsse aus? Mit ihren Heizungen.",
        "Womit überquert ein Datenschützer einen Fluss? Mit der Privatsphäre.",
        "Was macht ein Fisch auf dem Kettenkarussell? Er dreht Dorsch.",
        "Was ist mit Helium gefüllt und kann nicht still sitzen? Der Zappelin.",
        "Was darf man zu Coronaviren nicht sagen? Impfwörter.",
        "Durch welche Tiere kann man erfahren, wie spät es ist? Uhrzeitkrebse.",
        "Wann läuft ein Oktopus blau an? Wenn ihm der Kraken platzt.",
        "Warum gibt es im Wald kein Corona? Weil die Bäume Zwei-Ge haben.",
        "Wie kommt ein betrunkener Virologe nach Hause? Auf allen Viren.",
        "Was machen die Hersteller von Desinfektionsmitteln in Corona-Zeiten? Sie reiben sich die Hände!",
        "Wie nennt man einen Dorsch, der jammert? Kabeljaul.",
        "Wer lebt im Himalaya und bastelt gern? Der Kneti.",
        "Warum stolpert man an der Grenze zwischen Österreich und der Schweiz? Da Liechtenstein.",
        "Was macht die Kuh in der Band? Muh-sik.",
        "Warum verwenden Österreicher Schneekanonen? Weil sie den Hang dazu haben.",
        "Warum wurde die Bacardi-Fabrik geschlossen? Weil die Mitarbeiter dort nur rumgemacht haben,",
        "Warum investiert ein Keks Geld an der Börse? Er ist ein Spekulatius.",
        "Was macht der Frosch in der Petersilie? Kräuter-Quak.",
        "Welcher Vogel hat Darth Vader auf den Kopf geschissen? Der Star war's!",
        "Wie heißt die Fahrt ins Impfzentrum? Spritztour.",
        "Wie heißt der nordische Gott der Ungeduld? Hammersbald.",
        "Wie heißt ein kranker Star-Fotograf? Paparozzi.",
        "Was macht eine Uhr im Urlaub? Zeitreisen.",
        "Wie heißt der Erfinder der Short? Kurt C Hose.",
        "Was ist jemand, der Kekse klaut? Krüminell.",
        "Wo wohnt ein Kellner? Im Obergeschoss.",
        "Woran erkennt man, dass ein Schlagzeuger an die Tür klopft? Auf 2 und 4 geht die Katzenklappe auf.",
        "Weshalb können Spielwarendiebstähle oft nicht aufgeklärt werden? Es fehlt das entscheidende Puzzleteil.",
        "Wie nennt man ein französisches Pferd? Jean Paul Gaultier.",
        "Was steht auf dem Grabstein einer Putzfrau? Die kehrt nie wieder.",
        "Warum wird beim Streiten getanzt? Um zu disco-tieren.",
        "Wohin schwimmen Delfine nach der Hochzeit? In die Flipper-Wochen.",
        "Woran hat sich der Hirte geschnitten? An schaf-kantigem Papier.",
        "Was macht ein Penis auf einem Thron? Er-regiert.",
        "Was muss man studieren, wenn man Yogalehrer werden will? Matte.",
        "Was passiert mit jemandem, dem die Cola ausgegangen ist? Er wird Coleerisch.",
        "Wie lautet die E-Mail-Adresse eines Mönchs? Ora@Labora.",
        "Was wurde dem entflohenen Sträfling zum Verhängnis? Ein Flüchtigkeitsfehler.",
        "Welche Hülsenfrüchte haben viele Freunde? Kontaktlinsen.",
        "Wie heißt der Blumenladen von Tom Hanks? Florist Gump.",
        "Was ist warm und riecht nach Karotte? Ein Hasen-Pups.",
        "Wie lange ist Ramadan? Fast 'n Monat.",
        "Das beliebteste Fast Food Gericht in den USA? Schießburger.",
        "Wie nennt man eine günstige, klebrige Substanz? Spargel.",
        "Warum ist der Kokon leer? Wurde ausgeraupt.",
        "Was ist die Lieblings-Kampfsportart von Bäckern? Teig-wondo.",
        "Was ist das Lieblingstier eines Studenten? Der Klausurirrelefant.",
        "Wie nennt man eine Person, die nicht auf Oralverkehr steht? Einen Saugenichts.",
        "Wie klingelt ein Affe? King Kong!",
        "Wer hat riesige Hände und arbeitet im Krankenhaus? Eine Prankenschwester.",
        "Wer liefert Pakete immer erst nach langer Zeit? Die Spätition.",
        "Was macht man mit einem Kleber, der nicht klebt? Man erlässt einen Haftbefehl.",
        "Wie nennt man einen pünktlichen Asiaten? Thai-Ming.",
        "Wie nennt man eine Kneipe für Magier? Zaubar.",
        "Es gibt keine dicke Veganer, es gibt nur pflanzliche Fette!",
        "Ich hab nen neuen Fahrrad-Witz, aber den Fahrrad ich dir net!",
        "Schon mal ne Waschmaschine durch de Wald renne sehn? Nein? Siehst mal, wie schnell die sin'!",
        "Die Polizei hat einen Penis gefasst. Er hat gestanden.",
        "Ich bin zur Hälfte Grieche. Fetalicherseits!",
        "Wenn man seinen Kopf mit dem linken Ohr auf die heiße Herdplatte legt, dann kann man riechen wie blöd man ist!",
        "In der Regel haben Wikinger rote Bärte.",
        "Der hat nen Spiegeleierbauch: der braucht nen Spiegel um seine Eier zu sehn!",
        "Wenn man im Wort \"Frau\" nur 4 Buchstaben ändert, kommt \"Bier\" heraus.",
        "Was sagte Chuck Norris zu seinem Vater, als er auszog? \"So, jetzt bist du der Mann im Haus!\"",
        "Wenn Chuck Norris in eine Schulklasse geht stehen der Lehrer, die Schüler und die Stühle auf!",
        "Chuck Norris ist so gut bestückt... es reicht sogar für eine Fernbeziehung.",
        "Niemand sagt zu Chuck Norris, dass er sich verwählt hat. Die einzig richtige Antwort ist: \"Entschuldigung, ich bin am falschen Telefon.\"",
        "Chuck Norris braucht die Seife im Gefängnis nicht aufheben.",
        "Wenn Chuck Norris beim Schwarzfahren erwischt wird, schauen sich die Kontrolleure nur fragend an und steigen dann langsam, ohne hastige Bewegungen, aus.",
        "Chuck Norris würzt seine Steaks mit Pfefferspray.",
        "Chuck Norris hat keine Augenbrauen, das sind Augen-Bärte.",
        "Die Parkplätze von Chuck Norris sind mit einem Rollstuhlfahrer-Zeichen markiert und zwar als Warnung.",
        "Chuck Norris kocht für dich? Merke: Es schmeck hervorragen. Immer!",
        "Chuck Norris trägt keine Schuhe. Die Schuhe tragen ihn und zwar ohne zu meckern.",
        "Bei der Geburt von Chuck Norris sagte die Hebamme: \"Herzlichen Glückwunsch. Es ist ein Mann!\"",
        "Chuck Norris kann im Kinderkarussell überholen.",
        "Der Zug muss darauf achten, dass Chuck Norris nicht zu nah an der Bahnsteigkante steht.",
        "Wenn Chuck Norris zur Blumenschau geht, riechen die Blumen an ihm.",
        "Chuck Norris hat bei seiner Geburt den Rahmen mit rausgerissen.",
        "Was sagte Chuck Norris zu seinem Vater, als er auszog? \"So, jetzt bist du der Mann im Haus!\"",
        "Der neue Hund von Chuck Norris hat sofort verstanden, dass er seine Haufen selbst einsammeln soll.",
        "Wenn Chuck Norris Blut spenden geht, ist es nie sein eigenes.",
        "Bei IKEA geht Chuck Norris mit der gelben Tasche raus. Keiner sagt was.",
        "Es kursiert das Gerücht, dass Chuck Norris gegen einen Piraten gekämpft und verloren haben soll. Die Wahrheit ist, dass Chuck Norris dieses Gerücht selbst verbreitet hat, um noch mehr Piraten anzulocken.",
        "Wer vermöbelt mehr Leute, Ikea oder Chuck Norris? Das war eine rhetorische Frage.",
        "Der Zug wartet für Chuck Norris.",
        "Chuck Norris wurde mal geklont. Dann haben beiden gekämpft. Keiner hat verloren. Chuck Norris verliert nie.",
        "Chuck Norris hat seine eigene Witzekategorie.",
        "Chuck Norris sollte zu einem Termin vor Gericht. Der Richter ist seit 2 Wochen auf der Flucht.",
        "Chuck Norris Haus hat keine Türen, sondern nur eine Mauer durch die er läuft.",
        "In England fahren alle auf der linken Seite, weil Chuck Norris auf der rechten Seite fahren will.",
        "Wenn Chuck Norris ein Wort falsch schreibt, wird es sofort von der Redaktion im Duden geändert.",
        "Als Lee Harvey Oswalt auf Kennedy schoss, hat Chuck Norris die Kugeln mit seinem eigenen Bart abgefangen, und JFKs Kopf ist nur vor lauter Erstaunen explodiert.",
        "Riecht es wie Hühnchen? Sieht es aus, wie Hühnchen? Schmeckt es wie Hühnchen? Sagt Chuck Norris, es ist Rind? - Dann ist es Rind.",
        "Wäre Chuck Norris in Fokushima gewesen, dann hätte sich das AKW nicht getraut zu explodieren.",
        "Wenn Chuck Norris wütend ist, macht sich jeder in die Hosen. Und zwar in echt.",
        "Wenn Chuck Norris mit nassen Fingern an der Steckdose rumfummelt, kriegt das Kraftwerk einen Schlag.",
        "Chuck Norris kann eine Klappe mit zwei Fliegen erschlagen.",
        "Chuck Norris bekommt auch Geld für Flaschen ohne Pfand.",
        "Chuck Norris fällt nicht, er attackiert den Boden.",
        "Chuck Norris scheidet Lichtschwerter aus.",
        "Verhütung ist einer Fremdwort für Chuck Norris. Es gibt eh nichts, was vor ihm schützen könnte.",
        "Chuck Norris benötigt nur Stuntdoubles, wenn geweint wird.",
        "Wenn Chuck Norris an einem Spiegel vorbeigeht, zerspringt das Glass. Es kann nur einen Chuck Norris geben.",
        "Chuck Norris hatte mal 10kg zu viel auf der Waage. Er hat sich dann seine Brusthaare rasiert und war 20kg leichter.",
        "Als Chuck Norris geboren wurde, hat er die Nabelschnur selbst durchgebissen.",
        "Wenn ein Zug nicht mehr leben möchte, wirft er sich vor Chuck Norris.",
        "Aliens lassen sich von Chuck Norris entführen.",
        "Chuck Norris brachte seinem Vater bei, wie man ein richtiger Mann wird.",
        "Chuck Norris versteht Frauen und sie verstehen ihn.",
        "Was geht den Opfern von Chuck Norris als Letztes durch den Kopf? Seine Faust.",
        "Was passiert, wenn Chuck Norris den Schleudersitz betätigt? Das Flugzeug wird weggeschleudert.",
        "Feministinnen haben gegen die \"toxische Männlichkeit\" von Chuck Norris protestiert. Ratet mal, wer jetzt seine Hemden bügelt?",
        "Kornkreise im Feld sind auch nur Orte, wo Chuck Norris seine Roundhouse-Kicks praktiziert.",
        "Der Fahrer lässt Chuck Norris im Bus essen und laut Musik hören.",
        "Wenn Chuck Norris angeln geht, kommen die Fische von alleine raus.",
        "Chuck Norris hat Pickel, die Laser schießen.",
        "Wenn Chuck Norris zu seinem Hund “Sitz!” sagt, setzten sich all Leute, die es gehört haben.",
        "Chuck Norris hat auf seiner Tastatur keine Löschtasche. Chuck Norris macht keine Fehler.",
        "Chuck Norris darf im Schwimmbad rennen und vom Beckenrand springen.",
        "Angst vor Spinnen nennt man in Fachkreisen \"Arachnophobia\". Angst vorm Fliegen nennt man \"Aerophobia\". Angst vor Blut nennt man \"Hemophobia\". Angst vor Chuck Norris nennt man vernünftig.",
        "Chuck Norris kam mit nur einem Bein aus dem Krieg zurück. Bis heute weiß niemand, wem es gehörte.",
        "Chuck Norris hat niedrigen Blutdruck. Sein Kreislaufsystem würde es nicht wagen, ihm Druck zu machen.",
        "Zombies wurden von Chuck Norris erfunden. Er fand es zu langweilig, Leute nur einmal umzulegen.",
        "Chuck Norris hat versucht Gewicht zu verlieren. Jedoch verliert Chuck niemals.",
        "Auch Drehtüren sind nicht davor sicher, von Chuck Norris eingetreten zu werden.",
        "Chuck Norris darf bei McDonald's mit Monopolygeld bezahlen.",
        "Wenn der Teufel ausdrücken will, dass jemand übertreibt, sagt er immer: „Jetzt mal nicht sofort den Chuck Norris an die Wand.”",
        "Warum hat Chuck Norris keinen Schatten? Niemand verfolgt Chuck Norris!",
        "Chuck isst keinen Honig, er kaut Bienen!",
        "Boah ey, alle labern immer von Chuck Norris!!! Wenn es Chuck wirklich geben würde, stände er jetzt hinter mir und würde meinen Kopf auf die Tastatur schhhaah rhcsr höoah sidfsh gfdfd56gw3fd4 u65fdff dfiosga örhre rcjmceui5sn mhklxj lb mhkjc rukc4eo",
        "Wenn Chuck Norris in die Sonne sieht, muss die Sohne blinzeln.",
        "Chuck Norris hat bei dem Spiel: \"Reise nach Jerusalem\" immer einen Stuhl frei.",
        "Chuck Norris schläft nicht. Er wartet.",
        "Es gibt kein Steoride im Bodybuiling - Nur Menschen, die Chuck Norris angelächelt hat.",
        "Chuck Norris darf den Aufzug auch im Brandfall nutzen.",
        "Chuck Norris muss beim Zoll nie was vorzeigen.",
        "Es wird gemunkelt, dass unter dem Bart von Chuck Norris kein Kinn ist, sondern eine dritte Faust.",
        "Chuck Norris war als Kind Kamikaze-Pilot... 12 mal. Er wollte einfach immer wieder.",
        "Chuck Norris und Gott hatten mal einen Faustkampf. Hast du Gott jemals gesehen?",
        "Chuck Norris darf die Straße neben dem Zebrastreifen überqueren.",
        "Chuck Norris hatte mal einmal ein Wettrennen mit der Zeit. Die Zeit läuft immer noch.",
        "Was ist der Unterschied zwischen Chuck Norris und Gott? Gott kennt Gnade...",
        "Chuck Norris wurde von der hochgiftigen \"Black Mamba\" gebissen. Nach 3 Tagen Höllenqualen ist die Black Mamba verstorben.",
        "Geburtstage feiern Chuck Norris.",
        "Chuck Norris kann einen Hut aus einem Hasen zaubern.",
        "Warum weinen Kinder wenn sie auf die Welt kommen? Weil sie eine Welt mit Chuck Norris betreten haben.",
        "Chuck Norris braucht die Toilette nicht zu spülen. Er sagt einfach \"Buh!\".",
        "Chuck Norris kennt jede Einzelheit des deutschen Steuersystems.",
        "Wie isst Chuck Norris sein Frühstücksei? Er pellt dass Huhn.",
        "Chuck Norris ist Fallschirmspringen gegangen. Sein Fallschirm hat sich nicht geöffnet. Er ist den Fallschirm danach umtauschen gegangen.",
        "Chuck Norris bekommt nie Spam-Emails.",
        "Chuck Norris wartet nicht auf die Bahn. Die Bahn wartet auf Chuck Norris.",
        "Jemand forderte von Chuck Norris, er solle Leuten nicht ständig Roundhouse Kicks verpassen. Historiker sind sich einig, dass diese Forderung, der größte Fehler war, der jemals begangen wurde.",
        "Chuck Norris darf die Rettungsgasse auf der Autobahn benutzen.",
        "Wie heißt das Tagebuch von Chuck Norris? Guinessbuch der Rekorde!",
        "Chuck Norris rasiert sich nicht, er rodet.",
        "Warum bekommt Chuck Norris keine Grippe? Auch Vieren kennen Angst.",
        "Wenn Chuck Norris ins Kino geht, bekommt er ein Fernbedienung.",
        "Chuck Norris ging in den Apple Store und hat sich auf seinem iPhone \"Android\" installieren lassen.",
        "Wenn Chuck Norris Fallschirmspringen geht, braucht er keinen Fallschirm. Der Fallschirm braucht ihn.",
        "Chuck Norris tank nicht. Das Auto fährt aus Respekt.",
        "In einem Zimmer gibt es 156 Dinge mit denen dich Chuck Norris töten kann, einschließlich dem Raum.",
        "Der Abspann nach einem Film mit Chuck Norris, ist nicht die Aufzählung mit Leuten, die bei dem Film mitgemacht haben, sondern eine Liste mit Leuten, denen Chuck Norris einen Roundhousekick verpasst hat.",
        "Chuck Norris kann Blindenschrift sprechen.",
        "Wer würde gewinnen: Godzilla oder das Monster von Lochness? Wir werden es nie erfahren, weil Chuck Norris seine Haustiere nie gegeneinander kämpfen lässt.",
        "Chuck Norris bekommt in einem Schweizer Hotel ein Zimmer mit Meerblick.",
        "Chuck Norris bekommt bei Burgerking einen Big Mac.",
        "Chuck Norris darf an Tankstellen rauchen.",
        "Chuck Norris spielt Paint-Ball ohne Schutzkleidung.",
        "Chuck Norris und Superman haben gekämpft. Der Verlierer muss seine Unterhose außen tragen.",
        "Chuck Norris kennt keine Angst. Die Angst kennt ihn.",
        "Die Chinesen haben die große Mauer nur errichtet, um sich vor jemanden wie Chuck Norris zu schützen.",
        "Chuck Norris hat seine Führerscheinprüfung bestanden und zwar zu Fuß.",
        "Tiere streicheln sich selbst, wenn Chuck Norris in der Nähe ist, damit er es nicht machen braucht.",
        "Chuck Norris hat sich einmal im Wald verlaufen. Niemand hat den Wald jemals wiedergesehen.",
        "Chuck Norris kauft seine Adidas-Schuhe im Nike-Laden.",
        "Chuck Norris nießt mit offenen Augen.",
        "Chuck Norris wurde neulich geblitzt... Beim rückwärts einparken!!!",
        "Chuck Norris hat keinen Schatten. Die Wand möchte nur so aussehen wie Chuck Norris.",
        "Chuck Norris hat keine Pickel. Die hätten ohnehin zu viel Angst von Chuck Norris ausgedrückt zu werden.",
        "Chuck Norris spricht während der Fahrt mit dem Busfahrer.",
        "Wenn Arnold Schwarzenegger sagt „I will be back“, sagt er im Prinzip nur, dass er kurz bei Chuck Norris um Rat fragt.",
        "Chuck wurde nicht normal geboren. Er hat sich aus dem Bauch seiner Mutter durch einen Roundhouse Kick befreit. Kurz darauf ist ihm ein Bart gewachsen.",
        "Chuck kann eine Drehtür zuschlagen.",
        "Die Stiefel von Chuck Norris sind aus echten Cowboys!",
        "Chuck Norris schießt beim Fußball das Tor in den Ball.",
        "Der Sensenmann hat bei Chuck Norris angeklopft. Bis heute erholt sich der Sensenmann von seiner Nah-Chuck-Erfahrung.",
        "Chuck Norris schmeißt eine Party mit Gästen - 100 Meter weit.",
        "Chuck Norris bekommt bei Praktiker 20% auf alles. Auch auf Tiernahrung.",
        "Kinder tragen nachts Superman-Schlafanzüge. Superman trägt nachts einen Chuck Norris Schlafanzug.",
        "Egal wie laut du Bach hörst, Heiner hört Lauterbach.",
        "Hast du schon wieder mein Deo benutzt? – Ich bin Robin Hood. Ich stehle es und verteile es unter den Armen.",
        "Wie lautet der Vorname vom Reh? – Kartoffelpü.",
        "Ich habe ein Brötchen angerufen, aber es war belegt.",
        "Was macht ein Drache im Fußballstadion? Die Leute anfeuern.",
        "„Ich hab jetzt schon tagelang nicht mehr geschlafen“ – „Bist du da nicht total am Ende?“ – „Nein, nachts schlaf ich ja gut.“",
        "Hans-Dieter trägt Socken in Sandalen. Chuck Norris Stilbewusstsein zwingt ihn, Hans-Dieter einen Roundhouse-Kick zu verpassen – wegen Sandalismus.",
        "Was sticht und hat Spaß daran? – Eine Sadistel.",
        "Was sagt der große Stift zum kleinen? – Wachs mal, Stift.",
        "Ich habe beim Metzger angerufen, aber da ging kein Schwein dran.",
        "Über Tofu macht man keine Witze... das ist geschmacklos.",
        "Was ist gesund und kräftig und spielt den Beleidigten? – Ein Schmollkornbrot.",
        "Sie: „Und was ist so dein Lieblingsfilm?“ Er: „Tesafilm ist ein echt guter Streifen.“",
        "Was ist braun, knusprig und läuft mit dem Korb durch den Wald? – Brotkäppchen.",
        "Treffen sich zwei Deutschlehrer am Strand. „Genitiv ins Wasser!“ – „Wieso, ist es Dativ?“",
        "Nach einer langen Partynacht mit Schuhen im Bett aufwachen – der gestiefelte Kater.",
        "Mein Zahnarzt hat gesagt, dass ich eine Krone brau/che. Endlich einer, der mich versteht.",
        "Was passiert, wenn man Cola und Bier gleichzeitig trinkt? – Man colabiert.",
        "Was trinken Chefs? – Leitungswasser."
    ]